// Parses the Studio's server-sent events out of a fetch() body stream.
//
// EventSource cannot POST a message or send a bearer token, so the page reads
// the stream itself. Frames are "event: <type>\ndata: <one JSON line>\n\n";
// lines starting with ":" are keep-alives. A chunk can end mid-frame, so the
// unfinished tail is handed back to be prefixed to the next chunk.

/**
 * @param {string} buffer text received so far
 * @returns {{ events: Array<[string, any]>, rest: string }}
 */
export function parseEventFrames(buffer) {
  const events = [];
  const frames = buffer.split("\n\n");
  const rest = frames.pop();
  for (const frame of frames) {
    let type = null;
    let data = null;
    for (const line of frame.split("\n")) {
      if (line.startsWith(":")) continue;
      if (line.startsWith("event: ")) type = line.slice(7).trim();
      else if (line.startsWith("data: ")) {
        try {
          data = JSON.parse(line.slice(6));
        } catch {
          data = null;
        }
      }
    }
    if (type) events.push([type, data]);
  }
  return { events, rest };
}

/**
 * Reads a whole event-stream Response, calling onEvent(type, data) per frame.
 * Resolves when the server closes the stream.
 */
export async function readEventStream(response, onEvent) {
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const { events, rest } = parseEventFrames(buffer);
    buffer = rest;
    events.forEach(([type, data]) => onEvent(type, data));
  }
  buffer += decoder.decode();
  const { events } = parseEventFrames(`${buffer}\n\n`);
  events.forEach(([type, data]) => onEvent(type, data));
}
